module.exports = __webpack_public_path__ + "static/img/8.f9ff2c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/eng/8.png
// module id = n6o6
// module chunks = 0